import httpClient from '../httpClient';

const post = async (data) => {
  return await httpClient.post(`/answer_politic/`, data);
};

const getAll = async (data) => {
    return await httpClient.get(`/answer_politic/`);
};

const getAllByAnswer = async (id) => {
    return await httpClient.get(`/answer_politic/?filter[answer]=${id}`);
};

const get = async (id) => {
    return await httpClient.get(`/answer_politic/${id}/`);
};

const patch = async (id, data) => {
    return await httpClient.patch(`/answer_politic/${id}/`, data);
};

export {
    post,
    patch,
    getAll,
    get,
    getAllByAnswer,
};